export default __webpack_public_path__ + "static/media/arrow-bottom-left.25cd337c.svg";